export const EXECUTION_TABS = {
  ifc: "ifc",
  transientResponse: "transient_response",
} as const;

export type ExecutionTab = (typeof EXECUTION_TABS)[keyof typeof EXECUTION_TABS];

export const EXECUTION_TAB_IDS = [EXECUTION_TABS.ifc, EXECUTION_TABS.transientResponse] as const;
